import { Extension } from '@tiptap/core';

// Shared wherever a run needs a line-height matching its own font-size (both
// here, for sized runs, and in AnnouncementRichTextEditorContent, for empty
// paragraphs). The backend derives its line height directly from the font
// file's own metrics (ascent/descent) when rendering the preview image —
// which is exactly what the browser's "normal" line-height also does, once
// nothing else (like the paragraph's own strut) is competing with it.
export const ANNOUNCEMENT_LINE_HEIGHT = 'normal';

// A fork of mui-tiptap's FontSize extension
// (https://tiptap.dev/api/marks/text-style) that also pins line-height
// alongside font-size on the same span, so it's independent from the
// paragraph's own (zeroed-out) line-height (see
// AnnouncementRichTextEditorContent).
export const AnnouncementFontSize = Extension.create({
  name: 'fontSize',

  addOptions() {
    return {
      types: ['textStyle'],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize.replace(/['"]+/g, ''),
            renderHTML: (attributes) => {
              if (!attributes.fontSize) {
                return {};
              }
              return {
                style: `font-size: ${attributes.fontSize}; line-height: ${ANNOUNCEMENT_LINE_HEIGHT};`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize:
        (fontSize) =>
        ({ chain }) =>
          chain().setMark('textStyle', { fontSize }).run(),
      unsetFontSize:
        () =>
        ({ chain }) =>
          chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run(),
    };
  },
});
